import React from "react";
import TableViewer from "../TableViewer";
import { nanoid } from "nanoid";
import { addTopic, removeTopic } from "../../utils/socket.services";
import HttpServices from "../../utils/Http.services";
import ItemModal from "../../modals/ItemModal";
import RemoveModal from "../../modals/RemoveModal";
import FilterModal from "../../modals/FilterModal";
import CompactPagination from "../CompactPagination";
import { adminPages } from "../../variables/adminPages";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import { checkTranslation, phoneStandardView } from "../../utils/useful";
import Loader from "react-loader-spinner";

class TableWidget extends React.Component {

    state = {
        data: [],
        topicId: nanoid(10),
        limit: 30,
        extraItems: [],
        currentPage: 0,
        filter: {},
        filter2: {},
        totalCount: null,
    }

    componentDidMount() {
        const lim = this.props.widget?.limit
        if (lim != null) {
            this.setState({ limit: lim }, () => this.init())
        } else {
            this.init()
        }
    }

    componentDidUpdate(prevProps) {
        const wid = this.props.widget?._id ?? this.props.widget
        const prevWid = prevProps.widget?._id ?? prevProps.widget
        if (wid !== prevWid) {
            if (prevProps.widget?.page) {
                removeTopic(this.state.topicId, prevProps.widget.page, 'admin')
            }
            const lim = this.props.widget?.limit
            this.setState({
                topicId: nanoid(10),
                currentPage: 0,
                filter: {},
                filter2: {},
                totalCount: null,
                data: [],
                showTable: false,
                ...(lim != null ? { limit: lim } : {}),
            }, () => this.init())
        }
    }

    componentWillUnmount() {
        removeTopic(this.state.topicId, this.props.widget.page, 'admin')
    }

    init() {
        this.setState({ data: [], totalCount: null }, () => {
            this.fetchData(true)
        })
    }

    /**
     * postBody may use `{ __relativeGteDays: N }` for a filter field (e.g. cDate).
     * Replaced with `{ $gte: Date.now() - N * 24h }` so the window stays correct on every fetch.
     */
    applyPostBodyRelativeDates(filter) {
        if (!filter || typeof filter !== 'object') return
        Object.keys(filter).forEach((key) => {
            const v = filter[key]
            if (v && typeof v === 'object' && v.__relativeGteDays != null) {
                const days = Number(v.__relativeGteDays)
                if (!Number.isNaN(days) && days > 0) {
                    filter[key] = { $gte: Date.now() - days * 86400000 }
                }
            }
        })
    }

    openEditModal = (prop, index) => {
        this.itemModal.modal.showModal()
        this.setState({ currentItem: prop, currentIndex: index })
    }

    openRemoveModal = (prop, index) => {
        this.removeModal.modal.showModal()
        this.setState({ currentItem: prop, currentIndex: index })
    }

    openRefModal = (prop, index, reference) => {
        let page = adminPages[reference.ref]

        let _id = typeof prop == 'object' ? prop._id : prop

        let body = { filter: { _id } }

        if (page.page) {
            body.filter = { ...{ page: page.key, _id }, ...body.filter }
        }
        HttpServices.request(page.fetchOne, body, (fetchResult, fetchError) => {

            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                return
            }

            let newItem = { page, data: fetchResult.info }
            let extraItems = this.state.extraItems
            extraItems.push(newItem)
            this.setState({ extraItems }, () => {
                setTimeout(() => {
                    this['itemModal' + String(extraItems.length - 1)].modal.showModal()
                }, 10);
            })

        })

    }

    itemAdded = (newItem, modalIndex) => {

        if (newItem && modalIndex == null) {
            let data = [...this.state.data]
            data.splice(0, 0, newItem)
            this.setState({ data })
        } else {
            this.fetchData(true)
        }
    }

    itemEdited = (editedItem, id, modalIndex) => {
        if (modalIndex == null) {
            let data = this.state.data
            this.state.data.forEach((element, index) => {
                let id = element.id ?? element._id
                let currentId = this.state.currentItem.id ?? this.state.currentItem._id
                if (id === currentId) {
                    data[index] = Object.assign({}, editedItem)
                }
            })
            this.setState({ data })
        } else {
            this.fetchData()
        }
    }

    changePage = (index) => {
        this.setState({ currentPage: index }, () => {
            this.fetchData()
        })
    }

    openFilterModal() {
        this.filterModal.showModal()
    }

    doFilter = (data) => {
        this.setState({ currentPage: 0, filter2: data }, () => {
            this.fetchData(true)
            this.filterModal.modal.hideModal()
        })
    }

    filterLabelCreator(rawprop) {
        let prop = JSON.parse(JSON.stringify(rawprop))

        let value = prop.value
        if (prop.type == 'PhoneInput') {
            value = phoneStandardView(value)
        }

        if (prop.dictionary) {
            if (Array.isArray(value)) {
                for (let i = 0; i < value.length; i++) {
                    const element = value[i];
                    if (prop.dictionary[element]) {
                        value[i] = prop.dictionary[element]
                    }
                }
            } else {
                if (prop.dictionary[value]) {
                    value = prop.dictionary[value]
                }
            }
        }

        let label = checkTranslation(prop.label) + ' ' + prop.operator + ' ' + value

        return label
    }

    removeFilter = (prop) => {
        let filter2 = { ...(this.state.filter2 || {}) }
        delete filter2[prop.key]
        this.setState({ filter2 }, () => {
            this.fetchData(true)
        })
    }

    fetchData = (getCount) => {

        this.setState({ isLoadingData: true });
        let body = this.props.widget.filter ?? {}
        let page = this.props.widget
        body.limit = page.limit ?? this.state.limit
        body.skip = this.state.currentPage
        body.filter = this.state.filter ?? {}

        if (this.state.filter2) {
            body.filter2 = this.state.filter2
        }

        if (this.props.widget.postBody) {
            body.filter = { ...body.filter, ...this.props.widget.postBody }
        }

        if (this.props.widget.populate) {
            body.populate = this.props.widget.populate
        }

        if (this.props.widget.sort) {
            body.sort = this.props.widget.sort
        }
            if (this.props.widget.data) {
                body = { ...body, ...this.props.widget.data }
            }

        for (const [key, value] of Object.entries(body)) {
            if (typeof value === 'string' && /\{\{(.*?)\}\}/.test(value)) {

                if (this.props.variables) {
                    body[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                }
            }
        }

        for (const [key, value] of Object.entries(body.filter)) {
            if (typeof value === 'string' && /\{\{(.*?)\}\}/.test(value)) {

                if (this.props.variables) {
                    body.filter[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                }
            }
        }

        this.applyPostBodyRelativeDates(body.filter)

        if (this.state.totalCount == null || getCount) {
            body.getCount = true
        }

        body.page = page.page ?? page.key
        body.frame = page.page ?? page.key

        if (page.populates) {
            body.populates = page.populates
        }

        if (this.props.variables?.applet) {
            body.applet = this.props.variables.applet
        }

        HttpServices.request(page.fetchUrl, body, (fetchResult, fetchError) => {
            if (fetchError) {
                this.setState({ isLoadingData: false })
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                return
            }
            addTopic(this.state.topicId, page.page, 'admin', null, this.updateData)

            const nextTotal = fetchResult.count != null ? fetchResult.count : undefined
            this.setState({ data: [], showTable: false }, () => {
                setTimeout(() => {
                    this.setState({
                        data: fetchResult.info,
                        showTable: true,
                        isLoadingData: false,
                        ...(nextTotal !== undefined ? { totalCount: nextTotal } : {}),
                    })
                }, 100);
            })
        })
    }


    getLabel(dataObject) {
        if (this.state.thing?.structure) {
            for (let i = 0; i < this.state.thing.structure.length; i++) {
                const structure = this.state.thing.structure[i];
                if (structure.dataObject == dataObject) {
                    return structure.label
                }
            }

        }
    }


    updateData = (newData) => {
        console.log(newData)
    }


    fetchRemove = () => {
        const page = this.props.widget
        if (!page.removeUrl) {
            this.setState({ isLoadingRemove: false })
            return
        }
        this.setState({ isLoadingRemove: true })
        let id = this.state.currentItem._id
        HttpServices.request(page.removeUrl, { id, page: page.page ?? page.key }, (fetchResult, fetchError) => {
            this.setState({ isLoadingRemove: false })
            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: checkTranslation('{{lang}}Remove Failed'), description: checkTranslation(fetchError.message) })
                return
            }
            let data = this.state.data
            data.splice(this.state.currentIndex, 1)
            this.setState({ data })
            this.removeModal.modal.hideModal()
            this.props.actions.addNotif({ type: 'success', title: checkTranslation('{{lang}}Removed'), description: checkTranslation('{{lang}}Removed Record Successfully') })
            this.fetchData(true)
        })
    }

    functionsHandler = (prop, index, reference) => {

        if (this[reference.function]) {
            this[reference.function](prop, index, reference)
        }

    }


    render() {
        const w = this.props.widget

        const searchBtn = !w.hideFilter ? (
            <button
                type="button"
                onClick={() => this.openFilterModal()}
                className="flexcc p-0"
                aria-label={checkTranslation('{{lang}}Advanced Search')}
                style={{
                    flex: '0 0 auto',
                    width: 30,
                    height: 26,
                    boxShadow: '0px 0px 15px #00000005',
                    color: '#789',
                }}
            >
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" style={{ width: 22 }}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
                </svg>
            </button>
        ) : null

        return (
            <div className="w-100 d-flex flex-column" style={{ minHeight: 0, maxHeight: 600 }}>

                {this.state.filter2 && Object.keys(this.state.filter2).length > 0 && (
                    <div className="flexc mt-0 mb-2 px-0 flex-wrap">
                        {Object.values(this.state.filter2).map((prop, index) => {
                            return (
                                <div
                                    key={prop.key ?? index}
                                    className="flexcc mrd-1 mb-1"
                                    style={{
                                        backgroundColor: 'rgba(226, 193, 158, 0.15)',
                                        color: '#10453d',
                                        borderRadius: 20,
                                        padding: '3px 10px',
                                        fontSize: 12
                                    }}
                                >
                                    {this.filterLabelCreator(prop)}
                                    <button
                                        type="button"
                                        onClick={() => this.removeFilter(prop)}
                                        className="p-0 mld-2 border-0 bg-transparent"
                                        style={{ color: '#10453d', fontSize: 12 }}
                                    >
                                        <span className="flexcc">×</span>
                                    </button>
                                </div>
                            )
                        })}
                    </div>
                )}

                <div
                    className="flex-grow-1 position-relative w-100 custom-scrollbar-widget"
                    style={{ minHeight: 0, overflow: 'auto' }}
                >
                    {this.state.isLoadingData && !this.state.showTable && (
                        <div
                            className="flexcc w-100"
                            style={{ minHeight: 220, padding: "24px 0" }}
                            aria-busy="true"
                            aria-live="polite"
                        >
                            <Loader type="ThreeDots" color="#789" height={24} width={56} />
                        </div>
                    )}
                    {this.state.showTable && (
                        <TableViewer
                            isLoading={this.state.isLoadingData}
                            headers={this.props.widget?.headers}
                            page={this.props.widget}
                            data={this.state.data}
                            variables={this.props.variables}
                            top={0}
                            actions={this.props.widget?.actions}
                            openEditModal={this.openEditModal}
                            openRemoveModal={this.openRemoveModal}
                            functionsHandler={this.functionsHandler}
                            updateData={(data) => {
                                if (Array.isArray(data)) this.setState({ data })
                            }}
                        />
                    )}
                </div>

                <div
                    className="w-100 mt-1 p-0 border-top d-flex align-items-center flex-nowrap"
                    style={{
                        borderColor: 'rgba(148, 163, 184, 0.25)',
                        direction: 'ltr',
                        gap: 8,
                        paddingTop: 4,
                        paddingBottom: 2,
                    }}
                >
                    {searchBtn && (
                        <div className="d-flex align-items-center flex-shrink-0" style={{ marginInlineEnd: 4 }}>
                            {searchBtn}
                        </div>
                    )}
                    <div className="flex-grow-1" style={{ minWidth: 0 }}>
                        <CompactPagination
                            currentPage={this.state.currentPage}
                            totalCount={this.state.totalCount}
                            limit={w.limit ?? this.state.limit}
                            changePage={this.changePage}
                        />
                    </div>
                </div>

                <FilterModal
                    ref={el => this.filterModal = el}
                    initData={this.state.filter2}
                    page={w}
                    headers={w?.headers}
                    doFilter={this.doFilter}
                />

                <ItemModal
                    ref={el => this.itemModal = el}
                    page={this.props.widget}
                    headers={this.props.widget?.headers}
                    initData={this.state.currentItem}
                    variables={this.props.variables}
                    itemAdded={this.itemAdded}
                    itemEdited={this.itemEdited}
                    openRefModal={this.openRefModal}
                    functionsHandler={this.functionsHandler}
                    showDates={true}
                />


                {this.state.extraItems && this.state.extraItems.map((prop, index) => {
                    return (

                        <ItemModal
                            ref={el => this["itemModal" + index] = el}
                            page={prop.page}
                            headers={prop.page?.headers}
                            initData={prop.data}
                            variables={this.props.variables}
                            itemAdded={this.itemAdded}
                            itemEdited={this.itemEdited}
                            openRefModal={this.openRefModal}
                            functionsHandler={this.functionsHandler}

                            showDates={true}
                            modalIndex={index}
                        />

                    )

                })}


                <RemoveModal
                    isLoading={this.state.isLoadingRemove}
                    removeFunction={this.fetchRemove}
                    ref={el => this.removeModal = el}
                />

            </div >
        )
    }
}




const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TableWidget);
